<div class="howden-dialog-content">
  <div mat-dialog-title>Buscador de Clientes</div>

  <mat-dialog-content>
    <howden-clients-search-table [isDialog]="true"></howden-clients-search-table>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="onCancel()" i18n="@@app.core.actions.cancel">Cancelar</button>
  </mat-dialog-actions>
</div>
